var map = {
	"./1.png": 3381,
	"./2.png": 9916,
	"./3.png": 3740,
	"./4.png": 1375,
	"./5.png": 2270,
	"./6.png": 8409,
	"./7.png": 9289,
	"./8.png": 4117,
	"./9.png": 6946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3457;